export const MAX_SAVED_SEARCHES = 3;
export const MAX_RECENT_SEARCHES = 3;
